export const DEFAULT_TTL_SECONDS = 3600;
export const EXPIRY_ALERT_BUFFER_MS = 2 * 60 * 1000;

export function parseTTLSeconds(rawTtl) {
  const n = Number(rawTtl);
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_TTL_SECONDS;
}

export function getAlertTargetTs(expiresAt) {
  return expiresAt ? expiresAt - EXPIRY_ALERT_BUFFER_MS : null;
}

export function shouldShowExpiryAlertAt(expiresAt) {
  const target = getAlertTargetTs(expiresAt);
  return target !== null && Date.now() >= target;
}
